const keys = {
  suggestion: {
    carClaimDescription: {
      collision: 'Collision',
      fire: 'Fire',
      glassBreakage: 'Glass breakage',
      hail: 'Hail',
      liability: 'Liability',
      liabilityAndCollision: 'Liability and collision',
      otherNonResponsible: 'Other (non responsible)',
      theft: 'Theft',
      vandalism: 'Vandalism',
    },

    // Keep it in blocks to make it easier to compare with Fortus documentation
    drivingConvictionDescription: {
      // Severity minor (37)
      crowdingDriversSeat: 'Crowding driver seat',
      defectiveBrakes: 'Defective brakes',
      distractedDriving: 'Distracted driving',
      driversLicenseViolations: 'Driver licence violation',
      failingToShareRoad: 'Failing to share road',
      failingToSignal: 'Failing to signal',
      failingToYield: 'Failing to yield',
      failingToYieldPedestrian: 'Failing to yield to pedestrian',
      failureToCarryInsuranceCard: 'Failure to have insurance card',
      failureToProduceEvidenceOfInsurance: 'Failure to produce evidence of insurance',
      failureToUseSeatbelts: 'Failure to use seatbelts',
      followingTooClosely: 'Following too closely',
      headlightOffenses: 'Headlight offenses',
      improperDividedHighway: 'Improper use of divided highway',
      improperDrivingBusLane: 'Driving in bus lane',
      improperLaneChange: 'Improper lane change',
      improperOpeningDoor: 'Improper opening door',
      improperPassing: 'Improper passing',
      improperTowing: 'Improper towing',
      improperTurn: 'Improper turn',
      insecureLoad: 'Insecure load',
      minorConvictionNotSpecified: 'Other minor conviction',
      obstructingTraffic: 'Obstructing traffic',
      overload: 'Overloadad',
      prohibitedHandHeldDevice: 'Prohibited use of hand-held device (ex. cell phone)',
      railwayCrossing: 'Railway crossing',
      speeding: 'Speed over limit',
      stopSign: 'Infractions related to stop sign',
      trafficLight: 'Infractions related to traffic light',
      trailerPassenger: 'Trailer passenger',
      unnecessaryNoise: 'Unnecessary noise',
      unnecessarySlowDriving: 'Unnecessary slow driving',
      unsafeMove: 'Unsafe move',
      unsafeTurn: 'Prohibited turn',
      unsafeVehicle: 'Unsafe vehicle',
      viewObstructed: 'View obstructed',
      wrongWayOnOneWay: 'Wrong way on one way',

      // Severity major (10)
      failingReportAccident: 'Failing to report an accident',
      failureReportDamageHighway: 'Failure to report damage to highway property',
      falseStatementInsurance: 'False statement insurance',
      majorConvictionNotSpecified: 'Other major conviction',
      operateMotorVehicleWithoutInsurance: 'Operate motor vehicle without insurance',
      produceFalseInsurance: 'Produce false insurance',
      schoolBusFailStop: 'School bus improper passing or fail to stop',
      schoolPlaygroundImproperPassing: 'School playground improper passing',
      stunting: 'Stunt driving',
      vehicleOwnerWithoutInsurance: 'Vehicle owner without insurance',

      // Severity criminal (13)
      bloodAlcohol: 'Blood alcohol',
      carelessDriving: 'Careless driving',
      criminalNegligence: 'Criminal negligence',
      dangerousDriving: 'Dangerous driving',
      drivingWhileUnderSuspension: 'Driving while under suspension',
      failingObeyPolice: 'Failing to obey to police',
      failingRemain: 'Failing to remain at the scene of the accident',
      impairedDriving: 'Impaired driving',
      motorManslaughter: 'Motor manslaughter',
      racing: 'Racing',
      refuseBreathalyzer: 'Refuse breathalyzer',
      seriousConvictionNotSpecified: 'Other serious conviction',
    },

    floaterTypes: {
      animal: 'Domestic animal',
      art: 'Fine art',
      bicycle: 'Bicycle',
      collection: 'Collection',
      fur: 'Fur item',
      jewelry: 'Jewelry',
      tractor: 'Mowers and drawn machinery',
      watercraft: 'Watercraft',
    },

    // Financial Institutions list
    financialInstitutions: {
      alternaBank: '608 - CS Alterna Bank',
      alternaSavings: '842 - Alterna Savings',
      bankofMontreal: '001 - BMO - Bank of Montreal',
      caisseAlliance: '890 - Caisse Alliance',
      canadianWesternBank: '030 - Canadian Western Bank',
      central1CreditUnion: '828 - Central 1 Credit Union',
      cibc: '010 - CIBC - Canadian Imperial Bank of Commerce',
      desjardinsGroup: '815 - Desjardins Group',
      desjardinsOntarioCreditUnion: '829 - Desjardins Ontario Credit Union',
      equitableBank: '623 - Equitable Bank',
      hsbcBank: '016 - HSBC Bank Canada',
      laurentianBank: '039 - Laurentian Bank of Canada',
      manulifeBank: '540 - Manulife Bank of Canada',
      meridianCreditUnion: '837 - Meridian Credit Union',
      motusbank: '374 - Motusbank',
      nationalBank: '006 -National Bank of Canada',
      peoplesTrustBank: "621 - People's Trust Bank",
      presidentChoiceBank: "320 - President's Choice Bank",
      royalBank: '003 - RBC - Royal Bank of Canada',
      scotiabank: '002 - Scotiabank',
      tangerineBank: '614 - Tangerine Bank',
      tdBank: '004 -TD - The Toronto-Dominion Bank',
      vancityBank: '809 - Vancity Bank',
      wealthOneBank: '370 - Wealth One Bank',
      wealthsimple: '703 - Wealthsimple',
    },

    // Fire House distance
    fireStationDistance: {
      between8and13km: 'Between 8 and 13km',
      over13km: 'Over 13km',
      within8km: 'Within 8km',
    },

    // Labels for claims descriptions
    homeClaimDescription: {
      airConditioner: 'Air conditioner',
      bodilyInjury: 'Bodily injury ',
      burglary: 'Burglary or theft',
      cardFraud: 'Credit card fraud',
      earthquake: 'Earthquake',
      explosion: 'Explosion damage',
      exteriorSewerLine: 'Exterior sewer line damage',
      exteriorWaterLine: 'Exterior water line damage',
      fire: 'Fire damage',
      floodWater: 'Flood water damage',
      glass: 'Glass breakage',
      groundWater: 'Ground water damage',
      identityTheft: 'Identity theft ',
      other: 'Other',
      personalProperty: 'Personal property damage',
      sewerBackup: 'Sewer backup',
      vandalism: 'Vandalism',
      water: 'Water damage',
      windstorm: 'Windstorm or hail ',
    },

    months: {
      april: 'April',
      august: 'August',
      december: 'December',
      february: 'February',
      january: 'January',
      july: 'July',
      june: 'June',
      march: 'March',
      may: 'May',
      november: 'November',
      october: 'October',
      september: 'September',
    },

    mortgageLenders: {
      canadaDevelopmentBank: 'Business Development Bank of Canada - BDC',
      cibcBank: 'Canadian Imperial Bank of Commerce - CIBC',
      citiBank: 'Citibank',
      computershareTrustCompany: 'Computershare',
      desjardinsGroup: 'Desjardins Group',
      firstNational: 'First National Financial LP',
      hscbBank: 'HSBC Bank Canada',
      industrialAlliance: 'Industrial Alliance',
      ingBank: 'International Netherlands Group - ING',
      investorsGroup: 'Investors Group',
      johnDeere: 'John Deere Financial',
      kubota: 'Kubota Credit Corporation',
      laCapitale: 'La Capitale',
      laurentianBank: 'Laurentian Bank of Canada',
      manulifeBank: 'Manulife Bank',
      montrealTrustCompany: 'Montreal Trust Company of Canada - MTCC',
      nationalBank: 'National Bank',
      peoplesTrustCompany: 'Peoples Trust Company',
      quebecInvestment: 'Investissement Québec',
      royalBank: 'Royal Bank of Canada - RBC',
      schl: 'Canada Mortgage and Housing Corporation - CMHC',
      scotiaBank: 'Scotiabank',
      standardLife: 'Standard Life',
      tangerineBank: 'Tangerine Bank',
      tdBank: 'Toronto Dominion Bank - TD',
    },

    numberOfBathrooms: {
      one: '1',
      oneFullAndOneHalf: '1.5',
      two: '2',
      twoFullAndOneHalf: '2.5',
      // tslint:disable-next-line:object-literal-sort-keys
      three: '3',
      threeFullAndOneHalf: '3.5',
      four: '4',
      fourFullAndOneHalf: '4.5',
      five: '5',
      fiveFullAndOneHalf: '5.5',
      six: '6',
      sixFullAndOneHalf: '6.5',
    },

    occupationCategories: {
      agriculture: 'Agriculture and natural resources',
      art: 'Art and design',
      communication: 'Communication and documentation',
      construction: 'Construction and production',
      customerService: 'Customer service and salesperson',
      education: 'Education',
      engineering: 'Engineering',
      finance: 'Financial services',
      law: 'Law and public protection',
      maintenance: 'Maintenance and handling',
      medical: 'Medical',
      multimedia: 'Multimedia',
      publicCivilServices: 'Public civil services',
      science: 'Science (Physics, technology, etc)',
      socialServices: 'Social services',
      transport: 'Transport and machinery',
    },

    plumbingType: {
      abs: 'ABS',
      copper: 'Copper',
      copperAndAbs: 'Copper and ABS',
      galvanized: 'Galvanized',
      iron: 'Iron',
      other: 'Other',
      pex: 'PEX',
      pvc: 'PVC',
      kitec: 'Kitec',
      polyB: 'Poly-B (Polybutylene)',
    },

    // Labels for Provinces
    province: {
      alberta: 'Alberta',
      britishColumbia: 'British Columbia',
      manitoba: 'Manitoba',
      newBrunswick: 'New Brunswick',
      newfoundland: 'Newfoundland and Labrador',
      novaScotia: 'Nova Scotia',
      ontario: 'Ontario',
      priceEdwardIsland: 'Price Edward Island',
      quebec: 'Quebec',
      saskatchewan: 'Saskatchewan',
    },

    // Labels for relationship
    relationship: {
      boyfriendOrGirlfriend: 'Boyfriend / Girlfriend',
      family: 'Family',
      marriedOrCivilUnion: 'Married / Common law',
      other: 'Other',
      roomate: 'Roommate',
    },

    // Roof type labels
    roofType: {
      asphalt: 'Asphalt shingles',
      clay: 'Clay or Slate tile',
      metal: 'Metal',
      other: 'Other',
      rubber: 'Rubber',
      tar: 'Tar or gravel',
      wood: 'Wood shingles',
    },

    // Structure damages labels
    structureDamages: {
      damaged: 'Yes, not fixed yet',
      none: 'Never',
      repaired: 'Yes, it was fixed',
    },

    // Water hydrant distance
    fireHydrantDistance: {
      over300m: 'Over 300m',
      within300m: 'Within 300m',
    },

    // ranges for driving outside home province
    yearlyDaysOutsideOfProvince: {
      twentyOne: 'Less than 3 weeks',
      fortyNine: '4 to 7 weeks',
      oneHundredFive: '8 to 15 weeks',
      never: 'Never',
      oneHundredEightyTwo: '16 to 26 weeks',
      oneHundredEightyNine: 'Over 26 weeks or 6 months',
    },

    // Uninsured reasons for home / condo
    homeUninsuredReason: {
      cancelledByInsurer: 'I was cancelled by my previous insurer',
      financialIncapacity: 'I was experiencing financial incapacity',
      noMortgage: "I didn't have a mortgage, or my landlord didn't require it",
    },

    // Uninsured reasons for car
    carUninsuredReason: {
      cancelledByInsurer: 'I was cancelled by my previous insurer',
      vehiculeStored: 'The vehicle was stored',
      financialIncapacity: 'I was experiencing financial incapacity',
      newPurchaseOrTransfer: "It's a new purchase / ownership transfer",
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
